// Dynamic Firebase configuration based on client
const getClientFirebaseConfig = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME || 'demo-plutoo';
  
  let config;
  
  switch (companyName) {
    case 'tog-plutoo':
      config = {
        apiKey: process.env.REACT_APP_TOG_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_TOG_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_TOG_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_TOG_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_TOG_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_TOG_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_TOG_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_TOG_FIREBASE_MEASUREMENT_ID
      };
      break;
    case 'demo-plutoo':
      config = {
        apiKey: process.env.REACT_APP_DEMO_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_DEMO_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_DEMO_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_DEMO_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_DEMO_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_DEMO_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_DEMO_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_DEMO_FIREBASE_MEASUREMENT_ID
      };
      break;
    case 'sgh-plutoo':
      config = {
        apiKey: process.env.REACT_APP_SGH_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_SGH_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_SGH_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_SGH_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_SGH_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_SGH_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_SGH_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_SGH_FIREBASE_MEASUREMENT_ID
      };
      break;
    case 'ragdon-plutoo':
      config = {
        apiKey: process.env.REACT_APP_RAGDON_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_RAGDON_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_RAGDON_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_RAGDON_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_RAGDON_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_RAGDON_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_RAGDON_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_RAGDON_FIREBASE_MEASUREMENT_ID
      };
      break;
    default:
      // Fallback to demo configuration
      config = {
        apiKey: process.env.REACT_APP_DEMO_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_DEMO_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_DEMO_FIREBASE_DATABASE_URL,
        projectId: process.env.REACT_APP_DEMO_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_DEMO_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_DEMO_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_DEMO_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_DEMO_FIREBASE_MEASUREMENT_ID
      };
  }
  
  // Validate that required Firebase config values are present
  if (!config.apiKey) {
    const prefix = companyName === 'tog-plutoo'
      ? 'REACT_APP_TOG_FIREBASE_'
      : companyName === 'demo-plutoo'
      ? 'REACT_APP_DEMO_FIREBASE_'
      : companyName === 'sgh-plutoo'
      ? 'REACT_APP_SGH_FIREBASE_'
      : companyName === 'ragdon-plutoo'
      ? 'REACT_APP_RAGDON_FIREBASE_'
      : 'REACT_APP_DEMO_FIREBASE_';
    
    console.error(`
╔════════════════════════════════════════════════════════════════╗
║           FIREBASE CONFIGURATION ERROR                         ║
╠════════════════════════════════════════════════════════════════╣
║ Missing Firebase environment variables!                        ║
║                                                                ║
║ Company: ${companyName}                                        ║
║ Missing: ${prefix}API_KEY and related variables                ║
║                                                                ║
║ SOLUTION:                                                      ║
║ 1. Create a .env.local file in the project root               ║
║ 2. Add the required Firebase configuration variables          ║
║ 3. See ENVIRONMENT_VARIABLES_GUIDE.md for details             ║
║ 4. Restart your development server                            ║
║                                                                ║
║ Example for ${companyName}:                                    ║
║ REACT_APP_COMPANY_NAME=${companyName}                          ║
║ ${prefix}API_KEY=your-api-key-here                             ║
║ ${prefix}AUTH_DOMAIN=your-auth-domain                          ║
║ ${prefix}PROJECT_ID=your-project-id                            ║
║ ... (see ENVIRONMENT_VARIABLES_GUIDE.md for full list)        ║
╚════════════════════════════════════════════════════════════════╝
    `);
    
    throw new Error(`Firebase configuration error: Missing API key for company "${companyName}". Please create a .env.local file with the required Firebase environment variables. See ENVIRONMENT_VARIABLES_GUIDE.md for details.`);
  }
  
  return config;
};

const firebaseConfig = getClientFirebaseConfig();

export default firebaseConfig;